import { useEffect } from "react";

const METACRM_VISIBLE = [
  "restake",
  "defi",
  "dashboard",
  "wrap",
  "claim-kep",
  "gain",
];

const MetaCrmWidget = () => {
  useEffect(() => {
    const widget = document.getElementById("meta-crm-widget-container");
    if (
      widget &&
      METACRM_VISIBLE.includes(
        window.location.pathname.split("/").filter(Boolean).pop() || ""
      )
    )
      widget.style.display = "block";
    return () => {
      const widget = document.getElementById("meta-crm-widget-container");
      if (widget) widget.style.display = "none";
    };
  }, []);

  return null;
};

export default MetaCrmWidget;
